import { unwrap } from "@majourneys/api-client";
import type { SavedTripDto } from "@majourneys/shared";
import type { Trip } from "@majourneys/discover";
import { api } from "../../../lib/api";

/** /me/trips: the trips saved to the guest's account. */
export const tripsApi = {
  listMine: async (): Promise<SavedTripDto[]> => {
    const res = unwrap(await api.me.trips.get());
    return (res?.trips ?? []) as SavedTripDto[];
  },
  save: async (trip: Trip): Promise<void> => {
    unwrap(await api.me.trips({ id: trip.id }).put({ trip }));
  },
  remove: async (id: string): Promise<void> => {
    unwrap(await api.me.trips({ id }).delete());
  },
  /** Carry this device's trips onto the account (the guest chose to keep them). */
  sync: async (trips: readonly Trip[]): Promise<void> => {
    unwrap(await api.me.trips.sync.post({ trips: [...trips] }));
  },
};
